import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { GroupMember } from '../../../graphql/groups.datatypes';

interface GroupMembersData {
    groupMembersNoRoom: GroupMember[]
}

export const GET_GROUP_MEMBERS_NO_ROOM_QUERY = gql`
    query groupMembersNoRoom($group_id: Int) {
        groupMembersNoRoom(group_id: $group_id) {
            id
            first_name
            last_name
            email
            group_role

            group {
                id
                name
            }
        }
    }
`;

export const getGroupMembersNoRoom = (groupId?: number) => useQuery<GroupMembersData>(
    GET_GROUP_MEMBERS_NO_ROOM_QUERY,
    {
        variables: {
            group_id: groupId,
        },
    }
);

export default getGroupMembersNoRoom;
